import { RoleBasedGuard } from ".";
import { useAuthContext } from "../hooks"

export const EmployeeGuard = ({ children, roles = [] }) => {
  const { user: { Role: role } } = useAuthContext();

  return (
    <RoleBasedGuard acceptRoles={["Owner", "Admin", "Employee", ...roles]} currentRole={role} hasContent>
      {children}
    </RoleBasedGuard>
  )
}